export const exportQuotesToExcel = (quotes) => {
    if (!quotes || quotes.length === 0) {
        return;
    }

    const headers = [
        'Quote #',
        'Client Name',
        'First Name',
        'Last Name',
        'Email',
        'Phone',
        'Service Type',
        'Lead Source',
        'Boat Type',
        'Boat Year',
        'Boat Make',
        'Boat Length',
        'Boat Location',
        'Zip Code',
        'Location',
        'Status',
        'Created At',
        'Message',
    ];

    const rows = quotes.map(quote => {
        const clientName = `${quote.first_name || ''} ${quote.last_name || ''}`.trim() || quote.email || 'Unknown';

        return [
            quote.quote_number || `#${quote.id}`,
            clientName,
            quote.first_name || '',
            quote.last_name || '',
            quote.email || '',
            quote.phone || '',
            quote.service?.name || '',
            quote.lead_source?.name || '',
            quote.boat_type || '',
            quote.boat_year || '',
            quote.boat_make || '',
            quote.boat_length || '',
            quote.boat_location || '',
            quote.zip_code || '',
            quote.location || '',
            quote.status || '',
            quote.created_at || '',
            quote.message || '',
        ];
    });

    const csvContent = [
        headers.join(','),
        ...rows.map(row =>
            row.map(cell => {
                const cellValue = String(cell || '').replace(/"/g, '""');
                return `"${cellValue}"`;
            }).join(',')
        )
    ].join('\n');

    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    const timestamp = new Date().toISOString().split('T')[0];
    link.setAttribute('href', url);
    link.setAttribute('download', `quotes_export_${timestamp}.csv`);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
};

